import LocalConfigContext from "components/context/LocalConfigContext";
import AccountCard from "components/ui/AccountCard";
import { Heading } from "components/ui/Text";
import UILabel from "components/ui/UILabel";
import { useContext } from "react";
import {
  getDashboard,
  getOnboarding,
  getUsersProfile,
} from "store/api/apiSlice";
import { ApiUsersProduct } from "utils/api/users";
import { formatCurrency } from "utils/string";
import EwaDirectTile from "./EwaDirectTile";
import * as Styled from "./styled";

const Accounts = () => {
  const config = useContext(LocalConfigContext);
  const { data: user } = getUsersProfile();
  const { data: dashboard } = getDashboard();
  const { data: onboarding } = getOnboarding();

  const isEwaDirect = user?.product === ApiUsersProduct.ewaDirect;

  return (
    <Styled.Wrapper>
      <Styled.Header>
        <Heading.H4>Welcome back, {user?.firstName}!</Heading.H4>

        <Styled.Divider />
      </Styled.Header>

      {!onboarding?.complete && <EwaDirectTile />}

      <Styled.AccountList>
        <UILabel.Small wideCaps bold>
          Accounts
        </UILabel.Small>

        {onboarding?.complete && isEwaDirect && (
          <Styled.AccountLink to="/dashboard">
            <AccountCard
              name="Earnings account"
              accountNumber={config.showLastFour ? user?.lastFour : undefined}
              amount={dashboard?.safeToSpend || 0}
              amountLabel="Safe to spend"
              cardImageName="ewa-card"
            />
          </Styled.AccountLink>
        )}

        {onboarding?.complete && !isEwaDirect && (
          <Styled.AccountLink to="/dashboard">
            <AccountCard
              name="Checking account"
              accountNumber="0987"
              amount={dashboard?.safeToSpend || 0}
              amountLabel="Safe to spend"
              cardImageName="ewa-card"
            >
              <Styled.LineItems>
                <Styled.LineItem>
                  <Styled.LineItemText>Checking balance</Styled.LineItemText>
                  <Styled.LineItemValue>
                    ${formatCurrency(dashboard?.checkingBalance || 0)}
                  </Styled.LineItemValue>
                </Styled.LineItem>

                <Styled.LineItem>
                  <Styled.LineItemText>
                    Accrued net earnings
                  </Styled.LineItemText>
                  <Styled.LineItemValue>
                    ${formatCurrency(dashboard?.accruedNetEarnings || 0)}
                  </Styled.LineItemValue>
                </Styled.LineItem>
              </Styled.LineItems>
            </AccountCard>
          </Styled.AccountLink>
        )}

        {(!onboarding?.complete || isEwaDirect) && (
          <AccountCard
            name="Checking account"
            accountNumber="0987"
            amount={dashboard?.checkingBalance || 0}
            cardImageName={isEwaDirect ? "debit-card" : "ewa-card"}
          />
        )}

        <AccountCard
          name="Savings account"
          accountNumber="1234"
          amount={3850.25}
        />
      </Styled.AccountList>
    </Styled.Wrapper>
  );
};

export default Accounts;
